<template>
  <el-dialog width="1200px" title="Select Nominee Director" :close-on-click-modal="false" :visible.sync="visible" append-to-body top="5vh">
    <div class="pb10" v-loading="loading">
      <el-table :data="nomineeDirectorList" header-cell-class-name="table-header" @current-change="handleCurrentChange">
        <el-table-column width="60px" align="center" header-align="center">
          <template slot-scope="scope">
            <el-radio :label="scope.row" v-model="currRow" :disabled="scope.row.status == 0" class="ml10">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column label="Name" prop="fullName" align="center"></el-table-column>
        <el-table-column label="Nationality" prop="nationality" align="center"></el-table-column>
        <el-table-column label="Phone" prop="phone" align="center"></el-table-column>
        <el-table-column label="Email" prop="email" align="center"></el-table-column>
        <el-table-column label="Status" prop="status" align="center">
          <template slot-scope="scope">
            <span class="red" v-if="scope.row.status == 0">Disable</span>
            <span class="green" v-if="scope.row.status == 1">Enable</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :disabled="loading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    businessType: {
      type: String,
    },
    supplierList: {
      type: Array,
      default: () => [],
    },
    quotationList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      nomineeDirectorList: [],
      currRow: undefined,
      id: undefined,
      applymentId: undefined,
      loading: false,
    };
  },
  computed: {
    ...mapState("constant", ["nationalityList"]),
  },
  methods: {
    ...mapActions("applyment", ["doSaveRevising"]),
    async init(id) {
      this.visible = true;
      await this.$nextTick();
      this.initDirectorList();
      if (id) {
        this.id = id;
      }
    },
    handleCurrentChange(row) {
      // el-table 行点击总是 setCurrentRow(绕过 radio 的 disabled), 禁用行不允许成为选中项
      if (row && row.status == 0) return;
      this.currRow = row;
    },
    // 获取名义董事列表
    async initDirectorList() {
      this.loading = true;
      const { data } = await this.$http.get("/admin/stNomineeDirectorManage/getList");
      // 获取申请单关联供应商id列表
      let supplierIds = [];
      if (this.businessType == "COMPREHENSIVE_CUSTOMIZED" || this.businessType == "FUND_ADMIN_CUSTOMIZED") {
        const quotationList = this.quotationList || [];
        supplierIds = quotationList.map(ele => ele.supplier?.id).filter(v => v != null);
      } else {
        supplierIds = this.supplierList.map(ele => ele.id);
      }
      this.nomineeDirectorList = (data || []).filter(ele => supplierIds.includes(ele.supplierId));
      this.loading = false;
    },
    dataFormSubmit() {
      if (!this.currRow) {
        this.$message.warning("Please select a nominee director");
        return;
      }
      this.$emit("change", {
        id: this.id,
        nomineeDirectorId: this.currRow.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
